export type SessionStatus = 'open' | 'closed' | 'archived' | 'soft_deleted'

export interface SessionSettings {
  temperature?: number
  topP?: number
  maxTokens?: number
  frequencyPenalty?: number
  presencePenalty?: number
  seed?: number
  responseFormat?: string
  jsonMode?: boolean
}

export interface ChatMessage {
  id: string
  promptRequestId: string
  promptText: string
  settingsSnapshot: SessionSettings
  settingsBadge: string
  response?: {
    id: string
    normalizedText: string
    tokensInput: number
    tokensOutput: number
    estimatedCost: number
    latencyMs: number
    status: string
  }
  createdAt: string
}

export interface ChatSession {
  id: string
  modelId: string
  modelName: string
  categoryName?: string
  title: string
  status: SessionStatus
  systemPrompt?: string
  defaultSettings: SessionSettings
  messages: ChatMessage[]
  createdAt: string
  lastMessageAt?: string
  closedAt?: string
}

export interface SendMessageResult {
  requestId: string
  responseId: string
  normalizedText: string
  tokensInput: number
  tokensOutput: number
  estimatedCost: number
  latencyMs: number
  status: string
}

export interface StreamMessageHandlers {
  onMeta?: (meta: { requestId: string; responseId: string }) => void
  onChunk: (delta: string) => void
  onDone: (result: SendMessageResult) => void
  onError: (message: string) => void
  onCancelled?: (responseId?: string) => void
}

export const DEFAULT_SESSION_SETTINGS: SessionSettings = {
  temperature: 0.7,
  topP: 0.9,
  maxTokens: 4096,
  jsonMode: false,
}
